<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" >
                    <h4>グループメンバー一覧 - {{ organization_name }}</h4><br>
                    <v-btn class="white--text" color="blue-grey lighten-3" href="/documents/organizations">< 戻る</v-btn>
                </v-col>
                <template v-if="auth == true"> <!-- 管理者またはグループ管理者権限 -->
                    <v-col cols="12" xl="6" class="text-right">
                        <v-btn color="orange" class="white--text" @click="clickAdd(organization_id, users)">メンバーを追加する</v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="2">
                                    <badge-component tile color="unset">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-text-field v-model="searchItem.email" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="blue"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.users.email }}</td>
                            <td class="item-td" align="center">{{ item.users.name }}</td>
                            <td class="item-td" align="center">
                                {{ item.team_administrator_privileges ? '〇' : '' }}
                            </td>
                            <td class="item-td" align="center">
                                {{ item.document_manager ? '〇' : '' }}
                            </td>
                            <td class="item-td" align="center">
                                {{ item.confidential_document_manager ? '〇' : '' }}
                            </td>
                            <td align="center" >
                                <template v-if="auth == true"> <!-- 管理者またはグループ管理者権限 -->
                                    <v-btn color="blue" class="white--text" @click="clickDetail(item)">詳細</v-btn>
                                </template>
                            <td align="center" >
                                <template v-if="auth == true"> <!-- 管理者またはグループ管理者権限 -->
                                    <v-btn color="blue-grey" class="white--text" @click="clickDelete(item)">削除</v-btn>
                                </template>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
  
        <!-- メンバー追加 -->
        <organization-users-add-dialog-component v-if="addDialog" :addDialog.sync="addDialog" :item="{organization_id: organization_id, users: users}" @success="reSearch" @error="error">
            <template v-slot:ok-btn>追加</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </organization-users-add-dialog-component>

        <!-- 詳細 -->
        <organization-users-dialog-component v-if="detailDialog" :detailDialog.sync="detailDialog" 
            :item="{name: currentItem.users.name, email: currentItem.users.email,
                id: currentItem.id,
                team_administrator_privileges: currentItem.team_administrator_privileges,
                document_manager: currentItem.document_manager,
                confidential_document_manager: currentItem.confidential_document_manager}"
            @success="reSearch" @error="error"
        >
            <template v-slot:message>詳細</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </organization-users-dialog-component>
        
        <!-- 削除 -->
        <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-organization-users/'}" @success="reSearch" @error="error">
            <template v-slot:title>{{ currentItem.users.name }}をグループから削除しますか？</template>
            <template v-slot:message  v-if="currentItem.organization_id == currentItem.users.work_organization_id">作業グループに設定されています。</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    export default {
        props: {
            organization_id: String,
            organization_name: String,
        },
        data() {
            return {
                 // 項目一覧
                items: [],
                // 権限
                auth: [],
                // メンバー
                users: [],
                // 検索項目
                searchItem: {
                    email: '',
                    organization_id: this.organization_id,
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: 'メールアドレス', align: 'center', value: 'email' },
                  { text: '氏名', align: 'center', value: 'name' },
                  { text: 'グループ管理者', align: 'center', sortable: false },
                  { text: '書類管理者', align: 'center', sortable: false },
                  { text: '親展書類管理者', align: 'center', sortable: false },

                  { text: '', value: 'action', sortable: false },
                  { text: '', value: 'action', sortable: false },
                ],
                // 追加フラグ
                addDialog: false,
                // 詳細 開閉フラグ
                detailDialog: false,
                // 削除 開閉フラグ
                deleteDialog: false,
                // メッセージ
                message: null,
                success: false,
           };
        },
        methods: {
            // 追加ボタン押下
            clickAdd(organization_id, users) {
                this.addDialog = true;
                this.organization_id = organization_id;
                this.users = users;
            },
            // 詳細ボタン押下
            clickDetail(item) {
                this.detailDialog = true;
                this.currentItem = item;
            },
            // 削除ボタン押下
            clickDelete(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            // 検索
            search() {
                axios.post('/documents/search-organization-users', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.auth = res.data.auth;
                    this.users = res.data.users;
                });
            },
            // 再検索
            reSearch(message) {
                axios.post('/documents/search-organization-users', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.auth = res.data.auth;
                    this.users = res.data.users;
                    this.success = true;
                    this.message = message;
                });
            },
            // エラー
            error(message) {
                this.success = false;
                this.message = message;
            }
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-organization-users/' + this.organization_id).then((res) => {
                this.items = res.data.items;
                this.auth = res.data.auth;
                this.organization_id = res.data.organization_id;
                this.users = res.data.users;
            });
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>